import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { message } from 'antd'
import store from '@/store'
import { setAuthority, setToken, setUserId } from '@/features/Login/login'
import {
  BASE_URL,
  DOWNLOAD_URL,
  GRAPH_BASE_URL,
  MANAGE_BASE_URL,
  MINIO_BASE_URL,
  POEM_BASE_URL,
  SEALINFO_URL,
  SEGMENTINFO_URL,
  SRC_URL
} from './apiConfig'

const TIME_OUT = 20000
const TOKEN_EXPIRED_CODE = '10056'
let isHandlingTokenExpired = false

class TokenExpiredError extends Error {
  constructor() {
    super('Token expired')
    this.name = 'TokenExpiredError'
  }
}

function isTokenExpiredResponse(response?: AxiosResponse<any>) {
  if (!response) return false

  return String(response.data?.code) === TOKEN_EXPIRED_CODE
}

function handleTokenExpired() {
  if (isHandlingTokenExpired) return

  isHandlingTokenExpired = true
  store.dispatch(setToken(''))
  store.dispatch(setUserId(''))
  store.dispatch(setAuthority(-1))
  message.warning('登录已过期，请重新登录！')

  if (typeof window !== 'undefined' && window.location.pathname !== '/') {
    window.location.replace('/')
  }

  if (typeof window !== 'undefined') {
    window.setTimeout(() => {
      isHandlingTokenExpired = false
    }, 1000)
  } else {
    isHandlingTokenExpired = false
  }
}

function setupTokenExpiredInterceptor(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => {
      if (isTokenExpiredResponse(response)) {
        handleTokenExpired()
        return Promise.reject(new TokenExpiredError())
      }

      return response
    },
    (error) => {
      if (isTokenExpiredResponse(error?.response)) {
        handleTokenExpired()
      }

      return Promise.reject(error)
    }
  )
}

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: TIME_OUT
})
const instance_minio = axios.create({
  baseURL: MINIO_BASE_URL,
  timeout: TIME_OUT
})
const instance_graph = axios.create({
  baseURL: GRAPH_BASE_URL,
  timeout: TIME_OUT
})
const instance_poem = axios.create({
  baseURL: POEM_BASE_URL,
  timeout: TIME_OUT
})
const instance_sealInfo = axios.create({
  baseURL: SEALINFO_URL,
  timeout: TIME_OUT
})
const instance_segmentInfo = axios.create({
  baseURL: SEGMENTINFO_URL,
  timeout: 5000000
})
const instance_download = axios.create({
  baseURL: DOWNLOAD_URL,
  timeout: Number.MAX_VALUE
})

;[
  instance,
  instance_minio,
  instance_graph,
  instance_poem,
  instance_sealInfo,
  instance_segmentInfo,
  instance_download
].forEach(setupTokenExpiredInterceptor)

const httpRequest = {
  //@ts-ignore
  get(url: string, config?: AxiosRequestConfig) {
    return new Promise<any>((resolve, reject) => {
      instance
        .get(url, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  },
  post(
    url: string,
    data?: any,
    //@ts-ignore
    config?: AxiosRequestConfig
  ) {
    return new Promise<any>((resolve, reject) => {
      instance
        .post(url, data, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          console.log(123, err)
          reject(err)
        })
    })
  },
  delete(url: string, _config?: AxiosRequestConfig) {
    return new Promise<any>((resolve, reject) => {
      instance
        .delete(url)
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  }
}
const httpRequest_minio = {
  //@ts-ignore
  get(url: string, params: any, _config?: AxiosRequestConfig) {
    return new Promise<any>((resolve, reject) => {
      instance
        .get(url, { params: params })
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  },
  post(
    url: string,
    data?: any,
    //@ts-ignore
    config?: AxiosRequestConfig
  ) {
    return new Promise<any>((resolve, reject) => {
      instance_minio
        .post(url, data, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  }
}
const httpRequest_graph = {
  //@ts-ignore
  get(url: string, config?: AxiosRequestConfig) {
    return new Promise<any>((resolve, reject) => {
      instance_graph
        .get(url, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  }
}
const httpRequest_poem = {
  //@ts-ignore
  get(url: string, config?: AxiosRequestConfig) {
    return new Promise<any>((resolve, reject) => {
      instance_poem
        .get(url, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  }
}
const httpRequest_sealInfo = {
  //@ts-ignore
  get(url: string, config?: AxiosRequestConfig) {
    return new Promise<any>((resolve, reject) => {
      instance_sealInfo
        .get(url, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  },
  post(
    url: string,
    data?: any,
    //@ts-ignore
    config?: AxiosRequestConfig
  ) {
    return new Promise<any>((resolve, reject) => {
      instance_sealInfo
        .post(url, data, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  }
}
const httpRequest_segmentInfo = {
  //@ts-ignore
  get(url: string, config?: AxiosRequestConfig) {
    return new Promise<any>((resolve, reject) => {
      instance_segmentInfo
        .get(url, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  },
  post(
    url: string,
    data?: any,
    //@ts-ignore
    config?: AxiosRequestConfig
  ) {
    return new Promise<any>((resolve, reject) => {
      instance_segmentInfo
        .post(url, data, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  }
}
export const httpRequest_download = {
  //@ts-ignore
  get(url: string, config?: AxiosRequestConfig) {
    return new Promise<any>((resolve, reject) => {
      instance_download
        .get(url, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  },
  post(
    url: string,
    data?: any,
    //@ts-ignore
    config?: AxiosRequestConfig
  ) {
    return new Promise<any>((resolve, reject) => {
      instance_download
        .post(url, data, config ?? {})
        .then((res: any) => resolve(res))
        .catch((err: any) => {
          reject(err)
        })
    })
  }
}

/* 大众页面 - 首页 */

//登录
const login = (data: any) => {
  return httpRequest.post('/login', data)
}
//注册
const register = (data: any) => {
  return httpRequest.post('/register', data)
}
//搜索框模糊匹配
const searchMind = (data: any, token: string) => {
  return httpRequest.post(BASE_URL + '/searchmind', data, {
    headers: {
      Authorization: token
    }
  })
}
//获取某个作者的信息
const getAuthorInfo = (data: any, token: string) => {
  return httpRequest.post(BASE_URL + '/getauthorinfo', data, {
    headers: {
      Authorization: token
    }
  })
}
//获取某个作者卡片的信息
const getAuthorOnCard = (data: any, token: string) => {
  return httpRequest.post(BASE_URL + '/getauthorsoncard', data, {
    headers: {
      Authorization: token
    }
  })
}
//获取某个大洲馆藏的卡片信息
const getInstituteWorkByCriteria = (data: any, token: string) => {
  return httpRequest.post(BASE_URL + '/getinstituteworkbycriteria', data, {
    headers: {
      Authorization: token
    }
  })
}
// 搜索结果接口
const getSearchInfo = (data: any, token: string) => {
  return httpRequest.post(BASE_URL + '/search', data, {
    headers: {
      Authorization: token
    }
  })
}
// 获取有作品的作者首拼字母
const getAuthorsFirstCharacter = (token: string) => {
  return httpRequest.get(BASE_URL + '/getauthorsfirstcharacter', {
    headers: {
      Authorization: token
    }
  })
}
// 获取首页作品数量、作者数量信息
const getIndexMetaData = (token: string) => {
  return httpRequest.post(BASE_URL + '/getindexmetadata', {
    headers: {
      Authorization: token
    }
  })
}
/* 大众页面 - 搜索结果页面 */

//获取作品集合请求
const getWorkRequest = (data: any, token: string) => {
  return httpRequest.post(BASE_URL + '/getworkinfobycriteria', data, {
    headers: {
      Authorization: token
    }
  })
}

/* 大众页面 - 图像详情页面 */

//获取具体作品图像信息请求
const getImagesOfWorkRequest = (data: any, token: string) => {
  return httpRequest.post(BASE_URL + '/getimagesofwork', data, {
    headers: {
      Authorization: token
    }
  })
}
//获取具体作品文本信息请求
const getWorkMetadata = (data: any, token: string) => {
  return httpRequest.post(BASE_URL + '/getworkmetadata', data, {
    headers: {
      Authorization: token
    }
  })
}

/* 专家页面 - 数据概览页面 */
// 获取首栏数据
const getDataOverviewMetadata = (token: string) => {
  return httpRequest.get(BASE_URL + '/analysis/getmetadata', {
    headers: {
      Authorization: token
    }
  })
}
// 获取作品分布信息
const getWorkDistribution = (token: string) => {
  return httpRequest.get(BASE_URL + '/analysis/getworkdistribution', {
    headers: {
      Authorization: token
    }
  })
}
// 获取作者分布信息
const getAuthorDistribution = (token: string) => {
  return httpRequest.get(BASE_URL + '/analysis/getauthordistribution', {
    headers: {
      Authorization: token
    }
  })
}
// 获取朝代分布信息
const getDynastyDistribution = (data, token: string) => {
  return httpRequest.post(BASE_URL + '/analysis/getdistribution', data, {
    headers: {
      Authorization: token
    }
  })
}

/* 专家页面 - 画作选择页面 */

//导出搜索条件对应的文件
const downloadPageInfo = async (url: string) => {
  const eleLink = document.createElement('a')
  eleLink.href = url
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}

//通过SearchBox搜索，获取图片列表
const getWorkListByTags = (token: string, data: any) => {
  return httpRequest.post(BASE_URL + '/analysis/searchworkinfo', data, {
    headers: {
      Authorization: token
    }
  })
}

//画作对比：通过SearchBox搜索，获取图片列表
const getCompareWorkListByTags = (token: string, data: any) => {
  return httpRequest.post(BASE_URL + '/analysis/searchworkinfo', data, {
    headers: {
      Authorization: token
    }
  })
}

/* 专家页面 - 画作分析页面 */
//画作简介-获取imgInfo
const getPaintingIntro = (token: string, data: any) => {
  return httpRequest.post(BASE_URL + '/getworkinfobyworkid', data, {
    headers: {
      Authorization: token
    }
  })
}
//谢赫六法-根据画作uuid(imageId)获取六法信息
const getSixLawsInfo = (token: string, data: string) => {
  // return httpRequest.get("https://aailab.cn/annotations/default/" + data + ".json", {
  //   headers: {
  //     Authorization: token
  //   }
  // })
  return httpRequest.get(BASE_URL + '/getobjects', {
    params: { bucket: 'annotations', path: '/default/' + data + '.json' },
    headers: {
      Authorization: token
    }
  })
}
//谢赫六法-传移模写:根据画作uuid获取相似度最高的图像信息及其相似度
const getSimilarImgs = (token: string, data: any) => {
  return httpRequest.post(BASE_URL + '/getsimilarimages', data, {
    headers: {
      Authorization: token
    }
  })
}
//谢赫六法-传移模写:根据画作imageid获取其朝代、作者、图像链接信息
const getImgsInfoByImgID = (token: string, data: any) => {
  return httpRequest.post(BASE_URL + '/getworkinfobyimageid', data, {
    headers: {
      Authorization: token
    }
  })
}
// 画作对比：根据画作uuid(imageId)获取六法信息
const getCompareInfo = (token: string, data: string) => {
  // return httpRequest.get("https://aailab.cn/annotations/default/" + data + ".json", {
  //   headers: {
  //     Authorization: token
  //   }
  // })
  return httpRequest.get(BASE_URL + '/getobjects', {
    params: { bucket: 'annotations', path: '/default/' + data + '.json' },
    headers: {
      Authorization: token
    }
  })
}
// 画作对比-传移模写:根据画作uuid获取相似度最高的图像信息及其相似度
const getCompareSimilarImgs = (token: string, data: any) => {
  return httpRequest.post(BASE_URL + '/getsimilarimages', data, {
    headers: {
      Authorization: token
    }
  })
}
// 画作对比-传移模写:根据画作imageid获取其朝代、作者、图像链接信息
const getCompareImgsInfoByImgID = (token: string, data: any) => {
  return httpRequest.post(BASE_URL + '/getworkinfobyimageid', data, {
    headers: {
      Authorization: token
    }
  })
}
//上传当前画作收藏信息
const addCollectionPainting = (token: string, data: any) => {
  return httpRequest.post(BASE_URL + '/analysis/admin/addcollection', data, {
    headers: {
      Authorization: token
    }
  })
}
//获取当前画作收藏信息
const getHistoryPaintingInfo = (token: string, username: string, imageId: string) => {
  return httpRequest.get(BASE_URL + '/getobjects', {
    params: { bucket: 'annotations', path: username + '/' + imageId + '.json' },
    headers: {
      Authorization: token
    }
  })
}

//创作生成
const getPoem = (
  params: { caption: string; emotion: number; rhyme: number; yun: number },
  token: string
) => {
  return httpRequest_poem.get('', {
    params,
    headers: {
      Authorization: token
    }
  })
}

//印章分析
const getSealList = (url: string) => {
  return httpRequest_sealInfo.get(url)
}
const getSealListByAuthor = (url: string) => {
  return httpRequest_sealInfo.get(url)
}
const getOtherWorkSeal = (url: string) => {
  return httpRequest_sealInfo.get('/seal/workseal/getOtherWorkSeal/' + url)
}
const updateMatchSeal = (url: string, topk: string) => {
  return httpRequest_sealInfo.post(
    url,
    { topk },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )
}
const deleteSeal = (url: string, sealId: string[]) => {
  return httpRequest_sealInfo.post(url, sealId, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/* 专家页面 - 个人收藏页面 */
const getLikesList = (token: string, data: { page: number; size: number }) => {
  return httpRequest.post(BASE_URL + '/analysis/admin/getcollection', data, {
    headers: {
      Authorization: token
    }
  })
}

/* 管理员页面 */
const getQuery = (params: any, token: string) => {
  let str = ''
  for (const key in Object.keys(params)) str += '&' + key + '=' + params[key]
  return httpRequest_minio.get(MINIO_BASE_URL + '/query?' + str + '&Authorization=' + token, params)
}
const getQueryRange = (params: any, token: string) => {
  let str = ''
  for (const key in params) str += '&' + key + '=' + params[key]
  return httpRequest_minio.get(MINIO_BASE_URL + '/query_range?' + str + '&Authorization=' + token, {
    params
  })
}
const getManageList = (data: any, type: string, token: string) => {
  return httpRequest.post(MANAGE_BASE_URL + `/${type}/list`, data, {
    headers: {
      Authorization: token
    }
  })
}
const deleteManageItem = (key: string, type: string, token: string) => {
  return httpRequest.delete(MANAGE_BASE_URL + `/${type}/delete/${key}`, {
    headers: {
      Authorization: token
    }
  })
}
const insertManageItem = (data: any, type: string, token: string) => {
  return httpRequest.post(MANAGE_BASE_URL + `/${type}/insert`, data, {
    headers: {
      Authorization: token
    }
  })
}
const updateManageItem = (data: any, type: string, token: string) => {
  return httpRequest.post(MANAGE_BASE_URL + `/${type}/update`, data, {
    headers: {
      Authorization: token
    }
  })
}
const saveManageItem = (data: any, type: string, token: string) => {
  return httpRequest.post(MANAGE_BASE_URL + `/${type}/save`, data, {
    headers: {
      Authorization: token
    }
  })
}

// 分析页面 关联图谱
const getGraph = (name: string, token: string) => {
  return httpRequest_graph.get('/' + name, {
    headers: {
      Authorization: token
    }
  })
}

//图像标注页面
const savePic = (data: any) => {
  return httpRequest_segmentInfo.post('/savePic', data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
}
const saveResult = (data: any) => {
  return httpRequest_segmentInfo.post('/saveResult', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

const getResult = (data: any) => {
  return httpRequest_segmentInfo.post('/getResult', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

const getEverything = (data: any) => {
  return httpRequest_segmentInfo.post('/getEverything', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export { AI_PREDICTION_URL, DOWNLOAD_PAGE_URL } from './apiConfig'
export {
  SRC_URL,
  BASE_URL,
  SEGMENTINFO_URL,
  searchMind,
  getImagesOfWorkRequest,
  getWorkMetadata,
  getWorkRequest,
  getAuthorInfo,
  login,
  register,
  getAuthorOnCard,
  getWorkListByTags,
  getCompareWorkListByTags,
  getWorkDistribution,
  getAuthorDistribution,
  getPaintingIntro,
  getSixLawsInfo,
  getSimilarImgs,
  getImgsInfoByImgID,
  addCollectionPainting,
  getHistoryPaintingInfo,
  getQuery,
  getQueryRange,
  getManageList,
  deleteManageItem,
  insertManageItem,
  updateManageItem,
  saveManageItem,
  getInstituteWorkByCriteria,
  getSearchInfo,
  getGraph,
  getAuthorsFirstCharacter,
  getCompareInfo,
  getCompareSimilarImgs,
  getCompareImgsInfoByImgID,
  getIndexMetaData,
  getLikesList,
  getDataOverviewMetadata,
  getDynastyDistribution,
  getPoem,
  downloadPageInfo,
  getSealList,
  getSealListByAuthor,
  getOtherWorkSeal,
  updateMatchSeal,
  deleteSeal,
  savePic,
  saveResult,
  getResult,
  getEverything
}
